(function () {
  const qs = (sel, root = document) => root.querySelector(sel);

  const menuToggle = qs(".new-header__menu-toggle");
  const mobileMenu = qs(".new-header__mobile-menu");
  const mobileMenuClose = qs(".new-header__mobile-menu-close");

  const openMobileMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.classList.add("is-active");
    document.body.classList.add("overflow-hidden");
  };

  const closeMobileMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.classList.remove("is-active");
    document.body.classList.remove("overflow-hidden");
  };

  menuToggle?.addEventListener("click", (e) => {
    e.preventDefault();
    openMobileMenu();
  });

  mobileMenuClose?.addEventListener("click", (e) => {
    e.preventDefault();
    closeMobileMenu();
  });

  mobileMenu?.addEventListener("click", (e) => {
    const wrapper = e.target.closest(".new-header__mobile-menu-wrapper");
    if (!wrapper) closeMobileMenu();
  });

  document.addEventListener("click", (e) => {
    const link = e.target.closest(".new-header__mobile-link");
    if (link) closeMobileMenu();
  });

  const searchToggle = qs(".new-header__toggle-search");
  const searchBar = qs(".search-bar");
  const searchPanel = qs(".search-bar__panel");
  const searchInput = qs("#SearchBarInput");

  const openSearch = () => {
    if (!searchBar) return;
    searchBar.classList.add("is-active");
    document.body.classList.add("overflow-hidden");
    if (searchInput) setTimeout(() => searchInput.focus(), 50);
  };

  const closeSearch = () => {
    if (!searchBar) return;
    searchBar.classList.remove("is-active");
    document.body.classList.remove("overflow-hidden");
  };

  searchToggle?.addEventListener("click", (e) => {
    e.preventDefault();
    searchBar?.classList.contains("is-active") ? closeSearch() : openSearch();
  });

  document.addEventListener("click", (e) => {
    if (!searchBar || !searchBar.classList.contains("is-active")) return;

    const isInsideSearch = e.target.closest(".search-bar__panel");
    const isSearchToggle = e.target.closest(".new-header__toggle-search");

    if (!isInsideSearch && !isSearchToggle) {
      closeSearch();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;

    if (mobileMenu?.classList.contains("is-active")) closeMobileMenu();
    if (searchBar?.classList.contains("is-active")) closeSearch();
  });
})();

document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll(".new-header__mega-menu-wrapper");

  wrappers.forEach((wrapper) => {
    const trigger = wrapper.querySelector(".new-header__main-link");
    const menu = wrapper.querySelector(".new-header__mega-menu");
    if (!trigger || !menu) return;

    let closeTimer = null;

    const open = () => {
      if (closeTimer) clearTimeout(closeTimer);
      wrapper.classList.add("is-active");
      menu.classList.add("is-active");
      trigger.classList.add("is-active");
    };

    const close = () => {
      wrapper.classList.remove("is-active");
      menu.classList.remove("is-active");
      trigger.classList.remove("is-active");
    };

    wrapper.addEventListener("pointerenter", open);

    wrapper.addEventListener("pointerleave", () => {
      closeTimer = setTimeout(close, 120);
    });

    wrapper.addEventListener("pointermove", () => {
      if (closeTimer) clearTimeout(closeTimer);
    });
  });
});
